












import Vue, { PropType } from 'vue';

interface Item {
  status: string;
  ticket: string;
  booth: string;
  purchasedDate: string;
  expiration: string;
  period: string;
  buyer: string;
}

export default Vue.extend({
  name: 'GAccountContract',
  props: {
    listItems: {
      type: Array as PropType<Item[]>,
    },
  },
});
